module.exports = ".modal-content .modal-footer .btn.btn-default {\n  color: #000 !important;\n}\n\n.more-options-icon {\n  width: 20px;\n  cursor: pointer;\n}\n\n.more-options-icon:hover {\n  -webkit-filter: grayscale(100%);\n  /* Safari 6.0 - 9.0 */\n  filter: grayscale(100%);\n}\n\n.no-interaction {\n  opacity: .3;\n  cursor: not-allowed;\n}\n\n.lato{\n  font-family: 'Lato', sans-serif, fontaweomse\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main